<template>
  <div class="container">
    <Header
      :name="$t('app.profil.header')"
      :buttons="[
        {
          class: 'outline secondary icon icon-left',
          label: $t('app.profil.backToHome'),
          icon: 'bi-arrow-left',
          click: () => {
            $router.push({ name: 'home' });
          },
        },
      ]"
    />
    <TabsNavigation :tabs="tabsTitle" @changeTab="(value) => (state.currentTab = value)" />
    <transition mode="out-in" name="fade">
      <div class="primary-container" :key="state.currentTab">
        <div class="content-container">
          <component :is="tabsContent[state.currentTab]" />
          <div class="links-container">
            <a href="https://yuzu.hr/legal/cgu.pdf" target="_blank">
              {{ $t("app.profil.termsOfService") }}
            </a>
            <a href="https://yuzu.hr/legal/privacy.pdf" target="_blank">
              {{ $t("app.profil.privacyPolicy") }}
            </a>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
import { reactive } from "vue";
import Header from "@/components/Header.vue";
import Informations from "./partials/Informations.vue";
import Notifications from "./partials/Notifications.vue";
import Onboarding from "./partials/Onboarding.vue";
import { useRoles } from "@/queries/user.query.js";
import { MemberRole } from "@/types/role.js";

const { t } = useI18n();
const { data: roles } = useRoles();

const tabsContent = ref([Informations, Onboarding, Notifications]);
const tabsTitle = ref([t('app.profil.tabs.informations'), t('app.profil.tabs.onboarding')]);

const state = reactive({
  currentTab: 0,
});

watch(roles, () => {
  if (roles?.value?.find((role) => role.role_backward_compatibility_id === MemberRole.CONSULTANT)) {
    tabsContent.value = [Informations];
    tabsTitle.value = [t('app.profil.tabs.informations')];
  }
});

onMounted(() => {
  if (roles?.value?.find((role) => role.role_backward_compatibility_id === MemberRole.CONSULTANT)) {
    tabsContent.value = [Informations];
    tabsTitle.value = [t('app.profil.tabs.informations')];
  }
})
</script>
